import { toWSDateString } from "@wingspanhq/fe-component-library";
import { PayrollRun, PayrollRunCycleType } from "@wingspanhq/wingspan-api-sdk";

import { parsePayrollAmount } from "../utils";

import { selectorPayrollRunStatusPill } from "./selectorPayrollRunStatusPill";

/**
 * One payroll history row as a CSV record. Mirrors the visible table columns
 * plus the lifecycle dates behind them.
 *
 * "Total # of pay statements" is deliberately absent: the count lives on
 * `PayrollRun.breakdown`, which `listPayrollRuns` cannot expand — including it
 * would mean one extra `getPayrollRun` request per exported row.
 */
export const selectorPayrollRunCsvRow = (payrollRun: PayrollRun) => ({
  "Payroll ID": payrollRun.payrollNumber ?? payrollRun.id,
  Cycle:
    payrollRun.cycleType === PayrollRunCycleType.OFF_CYCLE
      ? "Off-cycle"
      : "On-cycle",
  "Pay period start": payrollRun.payPeriodStartDate
    ? toWSDateString(payrollRun.payPeriodStartDate, "input")
    : undefined,
  "Pay period end": payrollRun.payPeriodEndDate
    ? toWSDateString(payrollRun.payPeriodEndDate, "input")
    : undefined,
  "Pay date": payrollRun.payDate
    ? toWSDateString(payrollRun.payDate, "input")
    : undefined,
  Status: selectorPayrollRunStatusPill(payrollRun.status).text,
  Amount: parsePayrollAmount(payrollRun.totalAmount),
  Currency: payrollRun.currency?.toUpperCase(),
  "Finalization date": payrollRun.events?.finalizedAt
    ? toWSDateString(payrollRun.events.finalizedAt, "input")
    : undefined,
  "Paid date": payrollRun.events?.paidAt
    ? toWSDateString(payrollRun.events.paidAt, "input")
    : undefined
});
